export function calculateAPR(fees24h: number, tvl: number) {
  if (tvl === 0) return 0
  return (fees24h / tvl) * 365
}

export function calculateAPRPercent(fees24h?: number, tvl?: number) {
  if (!fees24h || !tvl) return 0

  return calculateAPR(fees24h, tvl) * 100
}
